import AppRequests from "components/ProjectSpecificComponents/API/AppRequests/AppRequests"
import { lostOrFinishedAdminSession } from "components/ProjectSpecificComponents/API/Functions/lostOrFinishedAdminSession"
import ROUTES from "components/ProjectSpecificComponents/Constants/ROUTES"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { TOnClick } from "components/ProjectSpecificComponents/Interfaces/GlobalInterface"
import { observer } from "mobx-react"
import React from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import MediumButton from "../../Global/atoms/Buttons/MediumButton"

interface Props {
	onClick?: TOnClick<HTMLButtonElement>
}

/**
 * Saves admin panel configuration (from all forms)
 * from anywhere in the application.
 */
const SaveAdminConfigurationButton = observer(({ onClick = () => {} }: Props) => {
	const store = useStore()
	const formStore = useFormStore()
	const { t } = useTranslation()
	const history = useHistory()

	const saveSettingsData = async () => {
		let errMsg: string | undefined = formStore.checkIfConfigSpecificValuesExists()

		if (errMsg) {
			store.setInfoModalConfig({
				type: "fail",
				titleKey: "",
				descriptionKey: errMsg,
			})
			return
		}
		let config = formStore.selectedFormsConfigId
		const { ok, statusCode } = await AppRequests("Setting").put("updateFormsConfig", config, {
			formsConfigId: config?.id,
		})

		if (ok) {
			store.setInfoModalConfig({
				type: "info",
				titleKey: "data-saving.success",
				showDuration: 1000,
			})
			//Updates config state before edit
			formStore.setSelectedConfigFormBeforeEdit()
		} else if (statusCode == 401) {
			lostOrFinishedAdminSession(history, store)
		} else {
			store.setInfoModalConfig({
				type: "fail",
				titleKey: "data-saving.failed",
			})
		}
	}

	const _onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		saveSettingsData()
		onClick(e)
	}

	return (
		<MediumButton
			style={{
				background: formStore.settingsData.personalize.colorHeaderText + "50" ?? "#267ce750",
				border: `2px solid ${formStore.settingsData.personalize.colorHeaderText ?? "var(--blue)"}`,
				color: formStore.settingsData.personalize.colorHeaderText ?? "var(--blue)",
				maxHeight: "90%",
			}}
			semiTransparent
			onClick={_onClick}
			children={t("rawText.saveChanges")}
		/>
	)
})

export default SaveAdminConfigurationButton
